<template>
  <div>
   
 <v-toolbar absolute>
  

    <h1>Монумент Киржач</h1>
     <v-spacer></v-spacer>
    
    <v-toolbar-items >
      <v-btn  to="/">Главная</v-btn>
      <v-btn to="/Contacts"> О нас</v-btn>
      
      
    <v-menu offset-y >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
        >
        Каталог
        </v-btn>
      </template>
      <v-list fixed>
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          :to="item.link"
          ixed
        >
          <v-list-tile-title fixed>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    </v-toolbar-items>
  </v-toolbar>


  </div>

</template>

<script>
export default { 
  name: 'Navigation',
  data: () => ({
      items: [
        { title: 'Галерея наших работ', link:"/Catalog" },
        { title: 'Памятники', link:"/Pamyatniki" }
      ]
    })
}
</script>

<style scoped>

</style>